import { jsx } from "panel";
import range from "lodash/range";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { WarningEl } from "common/components/warning";
import { WarningTheme } from "common/components/warning/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { CollapsibleTheme, SectionEl } from "common/components/section";
import { TextHighlightEl } from "common/components/text-highlight";
import { SpinnerEl } from "common/components/spinner";
import { QueryBlockEl } from "common/query-builder/query-block/panel";
import { SelectorType } from "common/query-builder/query-block/constants";
import { MenuType } from "common/query-builder/query-block/types";
import { TooltipEl } from "common/components/tooltip";
import { TimeQueryBlockEl } from "common/query-builder/query-block/time-menu/panel";
import { RecordingPlayerSource } from "../recording-player/types";
import { ProfileActivityPropertiesEl } from "./activity-properties";
function ViewReplaysButton(_ref) {
  var _profileActivity$getC;
  let {
    profileActivity
  } = _ref;
  const {
    t
  } = profileActivity.getContext("i18n");
  let tooltipText = null;
  if (!((_profileActivity$getC = profileActivity.getContext("currentProject").get().value) !== null && _profileActivity$getC !== void 0 && _profileActivity$getC.hasIntegratedSessionReplay)) {
    tooltipText = t("session-replay.integrate-replay", {
      docsLink: "https://docs.mixpanel.com/docs/session-replay"
    });
  } else if (profileActivity.state.loading.recordings) {
    tooltipText = t("profile.replays-loading");
  } else if (profileActivity.state.recordings.length === 0) {
    tooltipText = t("profile.replays-none");
  } else {
    tooltipText = t("profile.watch-replays-tooltip");
  }
  return /* @__PURE__ */ jsx("div", { sel: ".view-replays-button-container", "data-sentry-component": "ViewReplaysButton", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".control-button", attrs: {
    theme: ButtonTheme.Secondary,
    icon: "replay",
    disabled: profileActivity.state.recordings.length === 0
  }, on: {
    click: profileActivity.helpers.watchReplays
  }, elref: "viewReplaysButton", "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, t("profile.watch-replays"), profileActivity.state.loading.recordings && /* @__PURE__ */ jsx(SpinnerEl, null)), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    text: tooltipText,
    position: "top"
  }, "data-sentry-element": "TooltipEl", "data-sentry-source-file": "template.tsx" }));
}
export function template() {
  var _this$attr, _this$attr2;
  const isLoading = this.state.loading.initial || this.state.loading.eventDefinitions || this.state.loading.propertyDefinitions;
  const userActivity = this.helpers.getUserActivityDisplay();
  const {
    t,
    print
  } = this.getContext("i18n");
  return /* @__PURE__ */ jsx("div", { sel: ".profile-activity", class: {
    "sidebar-mode": this.attr("sidebar-mode")
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, !this.attr("sidebar-mode") && /* @__PURE__ */ jsx("div", { sel: ".title-bar" }, /* @__PURE__ */ jsx("div", { sel: ".activity-title" }, t("profile.activity-feed")), /* @__PURE__ */ jsx("div", { sel: ".filters-section" }, this.helpers.isSessionRecordingEnabled() && !this.attr("data-group-id") && /* @__PURE__ */ jsx(ViewReplaysButton, { profileActivity: this }), /* @__PURE__ */ jsx(ButtonEl, { sel: ".control-button", attrs: {
    theme: ButtonTheme.Secondary,
    icon: "line"
  }, on: {
    click: this.helpers.viewInInsights
  } }, t("profile.view-in-insights")), /* @__PURE__ */ jsx(TimeQueryBlockEl, { maxDataHistoryDays: (_this$attr = this.attr("history-limit-days")) !== null && _this$attr !== void 0 ? _this$attr : void 0, selected: this.state.dateRange, selectorType: SelectorType.Button, leftIcon: "calendar", trackName: this.helpers.REPORT_NAME, projectAsOfDate: (_this$attr2 = this.attr("project-as-of-date")) !== null && _this$attr2 !== void 0 ? _this$attr2 : void 0, onSelect: this.helpers.handleDateRangeSelected, onTrack: this.helpers.handleQueryBuilderBlockTrack }), /* @__PURE__ */ jsx(QueryBlockEl, { type: MenuType.Events, excludeCustomEvents: true, dataGroupId: this.attr("data-group-id").toString(), multiple: true, projectId: this.helpers.getProjectId(), selected: this.helpers.getSelectedHiddenEvents(), inverted: this.state.includedEvents.length > 0, includeHidden: true, selectorIcon: "eye-hide", selectorType: SelectorType.Button, showAllEvents: true, trackName: this.helpers.REPORT_NAME, workspaceId: this.helpers.getWorkspaceId(), onSelect: this.helpers.updateEventFilter, onTrack: this.helpers.handleQueryBuilderBlockTrack }))), !this.state.error && isLoading && /* @__PURE__ */ jsx("div", { sel: ".mp-panel-section" }, range(10).map((i) => /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-header", key: i }))), this.state.error && !isLoading && /* @__PURE__ */ jsx(WarningEl, { attrs: {
    "body-text": "We were unable to display this user's activity due to an error. Please try again later.",
    "header-text": "Unable to Display Activity Feed",
    theme: WarningTheme.Error
  } }), !this.state.error && !isLoading && /* @__PURE__ */ jsx(null, null, userActivity.length === 0 && /* @__PURE__ */ jsx("div", { sel: ".no-data-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".no-data-image" }), t("profile.no-activity"), " (", this.state.dateRange.getDisplayText(), ")"), userActivity.length > 0 && /* @__PURE__ */ jsx(null, null, userActivity.map((dayGroup) => /* @__PURE__ */ jsx("div", { sel: ".day-header" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "calendar"
  } }), print(dayGroup.dayHeader), /* @__PURE__ */ jsx("div", { sel: ".day-activities" }, dayGroup.activities.map((activity) => {
    const {
      eventName,
      eventGroup
    } = activity;
    const {
      time,
      insertId,
      replayId
    } = eventGroup[0];
    const hasBeenRendered = this.state.renderedGroupings.has(insertId);
    return /* @__PURE__ */ jsx("div", { sel: ".activity-event-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".activity-time" }, print(this.helpers.getDisplayTime(time))), /* @__PURE__ */ jsx("div", { sel: ".activity-name" }, /* @__PURE__ */ jsx(SectionEl, { attrs: {
      "enable-row-click": true,
      "is-closed": true,
      theme: CollapsibleTheme.INLINE
    }, on: {
      change: (ev) => this.helpers.handleExpandGrouping(ev, activity)
    } }, /* @__PURE__ */ jsx("div", { sel: ".activity-event-title", attrs: {
      slot: "title"
    } }, eventName, eventGroup.length > 1 && /* @__PURE__ */ jsx(TextHighlightEl, { attrs: {
      text: eventGroup.length
    } }), this.helpers.isSessionRecordingEnabled() && replayId && /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: "single-replay"
    }, on: {
      click: (ev) => {
        ev.stopPropagation();
        this.showRecordingsWithMetadataAsync([replayId], [this.attr("distinct-id")], RecordingPlayerSource.UsersProfile, !this.attr("sidebar-mode"));
      }
    } })), hasBeenRendered && eventGroup.length === 1 && /* @__PURE__ */ jsx("div", { sel: ".detail-pane" }, /* @__PURE__ */ jsx(ProfileActivityPropertiesEl, { attrs: {
      "utc-offset": this.attr("utc-offset"),
      "mixpanel-properties": eventGroup[0].mixpanelProperties,
      "user-defined-event-properties": eventGroup[0].userDefinedEventProperties,
      "event-name": eventName,
      time
    } })), hasBeenRendered && eventGroup.length > 1 && /* @__PURE__ */ jsx("div", { sel: ".event-group-pane" }, /* @__PURE__ */ jsx(EventGroup, { eventGroup, getDisplayTime: this.helpers.getDisplayTime, trackCollapsibleChange: this.helpers.trackCollapsibleChange, utcOffset: this.attr("utc-offset"), i18n: this.getContext("i18n") })))));
  })))), /* @__PURE__ */ jsx("div", { sel: ".activity-footer" }, /* @__PURE__ */ jsx("div", { sel: ".since-date-wrapper" }, "Since ", this.helpers.getLastVisibleFromDate()), /* @__PURE__ */ jsx("div", { sel: ".show-more-wrapper" }, this.state.loading.moreEvents ? /* @__PURE__ */ jsx(SpinnerEl, null) : this.state.enableShowMoreButton ? /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Secondary
  }, on: {
    click: this.helpers.handleShowMore
  } }, t("profile.show-more")) : null)))));
}
function EventGroup(_ref2) {
  let {
    eventGroup,
    getDisplayTime,
    trackCollapsibleChange,
    utcOffset,
    i18n
  } = _ref2;
  const {
    print
  } = i18n;
  return eventGroup.map((_ref3) => {
    let {
      mixpanelProperties,
      eventDisplayName,
      time,
      userDefinedEventProperties
    } = _ref3;
    return /* @__PURE__ */ jsx("div", { sel: ".grouped-event-row" }, /* @__PURE__ */ jsx("div", { sel: ".activity-ungrouped-time" }, print(getDisplayTime(time))), /* @__PURE__ */ jsx("div", { sel: ".activity-ungrouped-name" }, /* @__PURE__ */ jsx(SectionEl, { attrs: {
      "enable-row-click": true,
      "hide-caret": true,
      "is-closed": true,
      theme: CollapsibleTheme.INLINE
    }, on: {
      change: (ev) => trackCollapsibleChange(ev, eventDisplayName, time, false)
    } }, /* @__PURE__ */ jsx("div", { sel: ".expand-event-properties", attrs: {
      slot: "title"
    } }, eventDisplayName), /* @__PURE__ */ jsx("div", { sel: ".sub-event-pane" }, /* @__PURE__ */ jsx(ProfileActivityPropertiesEl, { attrs: {
      "utc-offset": utcOffset,
      "event-name": eventDisplayName,
      "mixpanel-properties": mixpanelProperties,
      "user-defined-event-properties": userDefinedEventProperties,
      time
    } })))));
  });
}
